module.exports = __webpack_public_path__ + "e954edc23e01f9155fbc7da12d8e4e84.pdf";